/**
 * Auto-generated API Client
 *
 * Generated by @spfn/core codegen
 * DO NOT EDIT MANUALLY
 *
 * @generated 2025-11-03T13:40:07.038Z
 */

import { client } from '@spfn/core/client';
import type { InferContract } from '@spfn/core';

import { getLabelVersionsContract } from '@/lib/contracts/labels';

// ============================================
// Types
// ============================================

export type GetLabelVersionsResponse = InferContract<typeof getLabelVersionsContract>['response'];
export type GetLabelVersionsParams = InferContract<typeof getLabelVersionsContract>['params'];

// ============================================
// API Functions
// ============================================

/**
 * GET /_cms/labels/:labelId/versions
 */
export const getLabelVersions = (options: { params: GetLabelVersionsParams }) => client.call(getLabelVersionsContract, options);

